@import 'src/main-dxp/view/styles/toyota-styles-base/elements/product-comparison/all';